module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sidebar) ? _c('aside', {
    staticClass: "modulesidebar"
  }, [(_vm.$slots.btn) ? _c('div', {
    staticClass: "modulesidebar__btn"
  }, [_vm._t("btn")], 2) : _vm._e(), (_vm.sidebar.events) ? _c('SidebarElement', {
    attrs: {
      "title": "Образовательные программы"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.events))]) : _vm._e(), (_vm.isProfession) ? _c('SidebarElement', {
    attrs: {
      "title": "Профессии"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.professonLink
    }
  }, [_vm._v(_vm._s(_vm.sidebar.profession.name))])], 1) : _vm._e(), (_vm.sidebar.competences) ? _c('SidebarElement', {
    attrs: {
      "title": "Компетенции"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.competences))]) : _vm._e(), (_vm.sidebar.cop_multi_name) ? _c('SidebarElement', {
    attrs: {
      "title": "Партнер ЦОПП"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.cop_multi_name))]) : _vm._e(), (_vm.sidebar.studentCategories) ? _c('SidebarElement', {
    attrs: {
      "title": "Категории обучающихся"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.studentCategories))]) : _vm._e(), (_vm.educationForm) ? _c('SidebarElement', {
    attrs: {
      "title": "Форма обучения"
    }
  }, [_vm._v(_vm._s(_vm.educationForm))]) : _vm._e(), _c('SidebarElement', {
    attrs: {
      "title": "ОВЗ",
      "inline": true
    }
  }, [_c('YesNo', {
    attrs: {
      "value": _vm.sidebar.isOvz
    }
  })], 1), (_vm.sidebar.freeCost) ? _c('SidebarElement', {
    attrs: {
      "title": "Бесплатно"
    }
  }, [_c('YesNo', {
    attrs: {
      "value": _vm.sidebar.freeCost
    }
  })], 1) : (_vm.sidebar.cost) ? _c('SidebarElement', {
    attrs: {
      "title": "Стоимость"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.cost))]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-183935e8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/modulesidebar/ModuleSidebar.vue
// module id = 03498c4cea515adf0109
// module chunks = 0